module.exports = __webpack_public_path__ + "static/img/58-2.807abd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/58-2.jpg
// module id = 8+8r
// module chunks = 0